export const Notescall = ({
  secondaryColor = "#3b4046",
  secondaryFontColor = "rgb(255, 255, 255)",
  width = "69",
  height = "69",
}) => {
  return (
    <svg
      id="Group_45238"
      data-name="Group 45238"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26.201 26.201"
    >
      <g id="phone-call">
        <g id="Group_43645" data-name="Group 43645">
          <path
            id="Path_65713"
            data-name="Path 65713"
            d="M22.362,3.835A13.1,13.1,0,1,0,26.2,13.1,13.1,13.1,0,0,0,22.362,3.835ZM19.84,18.249l0,0v0l-.664.659a3.494,3.494,0,0,1-3.3.943,11.608,11.608,0,0,1-3.371-1.511,15.576,15.576,0,0,1-2.659-2.144A15.7,15.7,0,0,1,7.86,13.783a12.226,12.226,0,0,1-1.493-3.022A3.493,3.493,0,0,1,7.24,7.193l.777-.777a.555.555,0,0,1,.784,0l0,0L11.257,8.87a.555.555,0,0,1,0,.784l0,0L9.816,11.1a1.175,1.175,0,0,0-.122,1.528,16.853,16.853,0,0,0,1.725,2.013,16.75,16.75,0,0,0,2.271,1.908,1.183,1.183,0,0,0,1.511-.131L16.594,15a.555.555,0,0,1,.784,0l0,0,2.459,2.463A.554.554,0,0,1,19.84,18.249Z"
            transform="translate(0 0)"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
};
